<div class="smart-question">
  <img src="/assets/images/question-menu/smart.svg">
  <p translate>questionBoard.edit.smart</p>
  <img src="/assets/images/question-menu/question-mark.svg">
</div>